import { useListInvoicesQuery, useReadInvoiceQuery } from '@/store/api/commercial/invoice.api';
import type { TypeApiError } from '@/types/api/types.api';
import type { TypeInvoice } from '@/types/commercial/types.commercial.invoice';

const EMPTY: TypeInvoice[] = [];

export const useInvoices = (): TypeInvoice[] => {
    const { data } = useListInvoicesQuery();
    return data ?? EMPTY;
};

export const useInvoicesState = () => {
    const { data, isLoading, isFetching, isError, error, refetch } = useListInvoicesQuery();
    return { invoices: data ?? EMPTY, isLoading, isFetching, isError, error, refetch };
};

export const useInvoiceDetail = (invoiceId: string | null) => {
    const { data, isLoading, isFetching, isError, error, refetch } = useReadInvoiceQuery(invoiceId as string, { skip: !invoiceId });
    const notFound = isError && (error as TypeApiError | undefined)?.status === 404;

    return {
        invoice: data ?? null,
        isLoading,
        isFetching,
        missing: notFound,
        isError: isError && !notFound,
        refetch,
    };
};
